import SelectInput from 'components/atoms/form/SelectInput/SelectInput'
import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import RateplansService from 'services/RateplansService'
import RoomTypesService from 'services/RoomTypesService'
import {addDaysToDate, getDateStringFromDate, getGapsInDateRanges, isArrayNotEmpty, multipleDateRangeOverlaps, searchFirstObjectInList, sortObjectList, isCompletedHotelInfoHistory} from 'utilities/JSUtil'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './OtherRateplans.scss'

class OtherRateplans extends Component {

    dayOfWeek = {
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true,
        sunday: true
    }

    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this)
        let hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        let hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)

        if (!hotelCode) {
            // Go home
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            initialValues: this.initialValues,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showErrorModal: false,
            isEditRoomTypes: [],
            hotelInfoCompletedHistory: hotelInfoCompletedHistory
        }
    }

    amountSchema = Yup.number()
        .required(FormConst.VALIDATION_ERROR_REQUIRED)
        .min(0, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_OR_EQUAL_TO_ZERO)

    datesRequiredPercentRatesSchema = Yup.array().of(
        Yup.object().shape({
            startDate: Yup.date().required(FormConst.VALIDATION_ERROR_REQUIRED),
            endDate: Yup.date().required(FormConst.VALIDATION_ERROR_REQUIRED)
                .when('startDate', (startDate) => startDate
                     && Yup.date().required(FormConst.VALIDATION_ERROR_REQUIRED)
                        .min(addDaysToDate(startDate, 1), 'End date should be after start date')
                        .max(addDaysToDate(startDate, FormConst.MAX_YEARS_END_DATE*365), FormConst.VALIDATION_ERROR_MAX_END_DATE)),
            singleAmount: this.amountSchema
        })
    )

    datesRequiredFlatRatesSchema = Yup.array().of(
        Yup.object().shape({
            startDate: Yup.date().required(FormConst.VALIDATION_ERROR_REQUIRED),
            endDate: Yup.date().required(FormConst.VALIDATION_ERROR_REQUIRED)
                .when('startDate', (startDate) => startDate
                     && Yup.date().required(FormConst.VALIDATION_ERROR_REQUIRED)
                        .min(addDaysToDate(startDate, 1), 'End date should be after start date')
                        .max(addDaysToDate(startDate, FormConst.MAX_YEARS_END_DATE*365), FormConst.VALIDATION_ERROR_MAX_END_DATE)),
            [FormConst.FIELD_1P]: this.amountSchema,
            [FormConst.FIELD_2P]: this.amountSchema
        })
    )

    datesOptionalPercentRatesSchema = Yup.array().of(
        Yup.object().shape({
            singleAmount: this.amountSchema
        })
    )

    datesOptionalFlatRatesSchema = Yup.array().of(
        Yup.object().shape({
            [FormConst.FIELD_1P]: this.amountSchema,
            [FormConst.FIELD_2P]: this.amountSchema
        })
    )

    validationSchema = Yup.object().shape({
        rateplans: Yup.array().of(
            Yup.object().shape({
                participating: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
                ratePlanType: Yup.string().optional(),
                ratePlanCode: Yup.string().optional(),
                rates: Yup.array()
                    .when([FormConst.FIELD_PARTICIPATING, FormConst.FIELD_RATEPLAN_CODE, FormConst.FIELD_RATEPLAN_TYPE], {
                        is: (participating, ratePlanCode, ratePlanType) => participating && this.isSgmOrState({ ratePlanCode: ratePlanCode }) && (ratePlanType === FormConst.RATE_TYPE_PERCENT || ratePlanType === FormConst.RATE_TYPE_AMOUNT),
                        then: this.datesRequiredPercentRatesSchema,
                    })
                    .when([FormConst.FIELD_PARTICIPATING, FormConst.FIELD_RATEPLAN_CODE, FormConst.FIELD_RATEPLAN_TYPE], {
                        is: (participating, ratePlanCode, ratePlanType) => participating && this.isSgmOrState({ ratePlanCode: ratePlanCode }) && ratePlanType === FormConst.RATE_TYPE_FLAT,
                        then: this.datesRequiredFlatRatesSchema,
                    })
                    .when([FormConst.FIELD_PARTICIPATING, FormConst.FIELD_RATEPLAN_CODE, FormConst.FIELD_RATEPLAN_TYPE], {
                        is: (participating, ratePlanCode, ratePlanType) => participating && !this.isSgmOrState({ ratePlanCode: ratePlanCode }) && (ratePlanType === FormConst.RATE_TYPE_PERCENT || ratePlanType === FormConst.RATE_TYPE_AMOUNT),
                        then: this.datesOptionalPercentRatesSchema,
                    })
                    .when([FormConst.FIELD_PARTICIPATING, FormConst.FIELD_RATEPLAN_CODE, FormConst.FIELD_RATEPLAN_TYPE], {
                        is: (participating, ratePlanCode, ratePlanType) => participating && !this.isSgmOrState({ ratePlanCode: ratePlanCode }) && ratePlanType === FormConst.RATE_TYPE_FLAT,
                        then: this.datesOptionalFlatRatesSchema,
                    }).test('Room type selection validation', function (rates) {
                        let selectedRoomTypes = 0
                        rates[0].roomTypes.forEach(roomType => {
                            if (roomType.isChecked) {
                                selectedRoomTypes++
                            }
                        })
                        if (selectedRoomTypes === 0) {
                            return this.createError({ message: `Atleast one room type required for rate plan ${this.parent.ratePlanCode}` })
                        } else {
                            return true
                        }
                    }).test('Seasons dates validation', function (rates) {
                        if (rates.length > 1) {
                            let dateRanges = []
                            rates.forEach(rate => {
                                if (rate.startDate && rate.endDate) {
                                    dateRanges.push({
                                        startDate: rate.startDate,
                                        endDate: rate.endDate
                                    })
                                }
                            })
                            let overlappingDateRanges = multipleDateRangeOverlaps(dateRanges)
                            if (isArrayNotEmpty(overlappingDateRanges)) {
                                return this.createError({
                                    message: `There are overlapping date ranges for rate plan ${this.parent.ratePlanCode}: 
                                [${getDateStringFromDate(overlappingDateRanges[0].startDate)}, ${getDateStringFromDate(overlappingDateRanges[0].endDate)}] 
                                and 
                                [${getDateStringFromDate(overlappingDateRanges[1].startDate)}, ${getDateStringFromDate(overlappingDateRanges[1].endDate)}]`
                                })
                            } else if (isArrayNotEmpty(getGapsInDateRanges(dateRanges))) {
                                const gaps = getGapsInDateRanges(dateRanges)
                                return this.createError(
                                    {
                                        message: `There are gaps in date ranges for rate plan ${this.parent.ratePlanCode}: `
                                            + gaps.map(gap => getDateStringFromDate(gap.startDate) + ' to ' + getDateStringFromDate(gap.endDate)).join(', ')
                                    })
                            }
                        }
                        return true
                    })
            })
        )
    })

    initialValues = {
        rateplans: []
    }

    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let roomTypes = this.state.hotelInfoCompletedHistory.newEntity?.hotelRoomTypes?.roomTypes;

            if (roomTypes && roomTypes.length > 0) {
                await RateplansService.getRateplans({ hotelCode: this.state.hotelCode })
                    .then(async response => {
                        let ratePlans = response.ratePlans;

                        await this.buildFormValues(roomTypes, ratePlans);
                    }).catch(error => {
                        this.setState({
                                          isLoading: false,
                                          showErrorModal: true,
                                          errorMessage: 'There was an error while reading rate plans data'
                                      })
                    })
            } else {
                this.setState({error: 'Could not retrieve details', isLoading: false})
            }
        } else {
            await RoomTypesService.getRoomTypes({ hotelCode: this.state.hotelCode })
                .then(async (response) => {
                    if (response.roomTypes && response.roomTypes.length > 0) {
                        let roomTypes = response.roomTypes;
                        // Now get the rateplans
                        await RateplansService.getRateplans({ hotelCode: this.state.hotelCode })
                            .then(async response => {
                                let ratePlans = response.ratePlans;

                                await this.buildFormValues(roomTypes, ratePlans);
                            }).catch(error => {
                                this.setState({
                                    isLoading: false,
                                    showErrorModal: true,
                                    errorMessage: 'There was an error while reading rate plans data'
                                })
                            })
                    } else {
                        this.setState({
                            isLoading: false,
                            showErrorModal: true,
                            errorMessage: 'No room types found'
                        })
                    }
                }).catch(error => {
                    this.setState({
                        isLoading: false,
                        showErrorModal: true,
                        errorMessage: 'There was an error while reading room types data'
                    })
                })
        }
    }

    async buildFormValues(roomTypes, ratePlans) {
        // Roomtypes from RoomTypesService response
        let roomTypesCodes = roomTypes.map(roomType => roomType.hotelRoomTypeCode)

        if (ratePlans && ratePlans.length > 0) {
            let rateplans = ratePlans
            let isEditRoomTypes = []

            rateplans.forEach(rateplan => {
                rateplan.participating = rateplan.onboardingParticipationMandatory || rateplan.participating
                // Set edit index
                isEditRoomTypes.push(false)

                let rates = rateplan.rates
                if (isArrayNotEmpty(rates)) {
                    // Rates are present
                    rates.forEach(rate => {
                        if (rate.roomTypes && rate.roomTypes.length > 0) {
                            const existingRoomTypes = rate.roomTypes
                            rate.roomTypes = roomTypesCodes.map(roomType => {
                                const wasChecked = existingRoomTypes.includes(roomType)
                                // If the room type is new (not in the previously saved list) and the
                                // rate plan does NOT allow room type changes, auto-select it so that
                                // newly added room types are not silently excluded.
                                const autoSelect = !wasChecked && !rateplan.onboardingRoomTypeChangeAllowed
                                return {
                                    code: roomType,
                                    isChecked: wasChecked || autoSelect
                                }
                            })
                        } else {
                            rate.roomTypes = roomTypesCodes.map(roomType => {
                                return {
                                    code: roomType,
                                    // Default select all
                                    isChecked: true
                                }
                            })
                        }

                        // Map rates
                        if (rateplan.ratePlanType === FormConst.RATE_TYPE_FLAT) {
                            rate.prices.forEach(price => {
                                if (price.condition === FormConst.CONDITION_VALUE_ONE_PERSON) {
                                    rate[FormConst.FIELD_1P] = price.amount
                                } else {
                                    rate[FormConst.FIELD_2P] = price.amount
                                }
                            })
                            rate.singleAmount = 0
                        } else {
                            rate.singleAmount = rate.prices[0].amount
                            rate[FormConst.FIELD_1P] = 0.00
                            rate[FormConst.FIELD_2P] = 0.00
                        }

                        rate.prices = undefined
                    })
                    rateplan.rates = sortObjectList(rates, 'startDate')
                } else {
                    // Rates are missing, user hasn't opted in yet, set default values for amount
                    rateplan.rates = [{
                        roomTypes: roomTypesCodes.map(code => {
                            return {
                                code: code,
                                isChecked: true
                            }
                        })
                    }]

                    if (rateplan.ratePlanType === FormConst.RATE_TYPE_FLAT) {
                        rateplan.rates[0][FormConst.FIELD_1P] = 0.0
                        rateplan.rates[0][FormConst.FIELD_2P] = 0.0
                    } else {
                        rateplan.rates[0]['singleAmount'] = 0.0
                    }
                }
            })


            // Move STATE and SGM to the top
            const rateplansToMove = rateplans.filter(rateplan => this.isSgmOrState(rateplan))
            const remainingRateplans = rateplans.filter(rateplan => !this.isSgmOrState(rateplan))

            rateplans = [...rateplansToMove, ...remainingRateplans]

            this.setState({
                isLoading: false,
                initialValues: {
                    rateplans: rateplans
                },
                roomTypes: roomTypesCodes
            })
        } else {
            this.setState({
                isLoading: false,
                roomTypes: roomTypesCodes,
                rateplans: []
            })
        }
    }

    onEditRoomTypes = (index) => {
        let isEditRoomTypes = [...this.state.isEditRoomTypes]
        isEditRoomTypes[index] = true
        this.setState({
            isEditRoomTypes: isEditRoomTypes
        })
    }

    onSaveRoomTypes = (index) => {
        let isEditRoomTypes = [...this.state.isEditRoomTypes]
        isEditRoomTypes[index] = false
        this.setState({
            isEditRoomTypes: isEditRoomTypes
        })
    }

    addSeason = (values, rateplanIndex) => {
        let rateplans = [...values.rateplans]
        let rateplanToEdit = rateplans[rateplanIndex]
        if (rateplanToEdit.ratePlanType === FormConst.RATE_TYPE_FLAT) {
            rateplanToEdit.rates.push({
                ...rateplanToEdit.rates[0],
                'startDate': '',
                'endDate': '',
                [FormConst.FIELD_1P]: 0.00,
                [FormConst.FIELD_2P]: 0.00
            })
        } else {
            rateplanToEdit.rates.push({
                ...rateplanToEdit.rates[0],
                'startDate': '',
                'endDate': '',
                'singleAmount': 0.00
            })
        }
        this.setState({
            initialValues: {
                ...values,
                rateplans: [...rateplans]
            }
        })
    }

    deleteSeason = (values, rateplanIndex, rateIndex) => {
        let rateplans = [...values.rateplans]
        let rateplanToEdit = rateplans[rateplanIndex]
        rateplanToEdit.rates.splice(rateIndex, 1)
        this.setState({
            initialValues: {
                ...values,
                rateplans: [...rateplans]
            }
        })
    }

    handleSubmit = (data) => {
        let putData = {
            hotelCode: this.state.hotelCode

        }
        const participatingRateplans = data.rateplans.filter(rateplan => rateplan.participating)

        putData.ratePlans = participatingRateplans.map(participatingRateplan => {
            return {
                ratePlanCode: participatingRateplan.ratePlanCode,
                ratePlanType: participatingRateplan.ratePlanType,
                baseRatePlanCode: participatingRateplan.ratePlanType === FormConst.RATE_TYPE_PERCENT ? FormConst.RATEPLAN_CODE_BASE : undefined,
                rates: isArrayNotEmpty(participatingRateplan.rates) ? participatingRateplan.rates.map(rate => {

                    let prices = []

                    if (participatingRateplan.ratePlanType === FormConst.RATE_TYPE_FLAT) {
                        prices.push({
                            amount: rate[FormConst.FIELD_1P],
                            condition: FormConst.CONDITION_VALUE_ONE_PERSON
                        })
                        prices.push({
                            amount: rate[FormConst.FIELD_2P],
                            condition: FormConst.CONDITION_VALUE_TWO_PERSON
                        })
                    } else {
                        prices.push({
                            amount: rate['singleAmount']
                        })
                    }
                    return {
                        tier: FormConst.TIER_1,
                        startDate: rate.startDate,
                        endDate: rate.endDate,
                        prices: prices,
                        dayOfWeek: participatingRateplan.ratePlanType === FormConst.RATE_TYPE_FLAT ? { ...this.dayOfWeek } : undefined,
                        roomTypes: rate.roomTypes.filter(roomType => roomType.isChecked).map(roomType => roomType.code)
                    }
                }) : undefined
            }
        })
        this.props.onPut(putData)
        this.setState({ isLoading: true, loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    errorMessage: this.props.errorDescription,
                    showErrorModal: true
                })
            } else {
                this.props.history.push(RouteConst.ROUTE_RATEPLANS_PAGE)
            }
        }
    }

    isAllRoomTypes = (roomTypes) => {
        if (!isArrayNotEmpty(roomTypes)) {
            return false
        }
        let result = searchFirstObjectInList('isChecked', false, roomTypes) ? false : true
        return result
    }

    isSgmOrState = (rateplan) => {
        return rateplan.ratePlanCode === FormConst.RATEPLAN_CODE_SGM || rateplan.ratePlanCode === FormConst.RATEPLAN_CODE_STATE
    }

    render() {
        return (
            <div className='other-rateplans-page'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_RATEPLANS_PAGE}>Rate Plans</NavLink></li>
                        <li className="breadcrumb-item active" aria-current="page">Other Rate Plans</li>
                    </ol>
                </nav>

                <Formik
                    initialValues={this.state.initialValues}
                    validationSchema={this.validationSchema}
                    enableReinitialize={true}
                    onSubmit={(data, { setSubmitting, resetForm }) => {
                        setSubmitting(true)
                        this.handleSubmit(data)
                        setSubmitting(false)
                    }}>
                    {
                        ({ values, errors, touched, dirty, isSubmitting, isValid, resetForm, handleChange, setFieldValue }) => (
                            <>
                                <h5 className='d-block d-xl-none text-center mt-5'>{FormConst.PAGE_NOT_ACCESSIBLE_ON_DEVICE}</h5>
                                <div className='other-rateplans-form d-none d-xl-block'>
                                    <Form>
                                        <div id='other-rateplans-form-fields' className='other-rateplans-form-fields'>
                                            <p className='other-rateplans-form-helper-text'>Other Rate Plans</p>
                                            <p>These are the list of other rate plans that are available. Some of these are mandatory. You can select the optional ones by selecting the opt-in checkbox.</p>
                                            <p>Changing room types is allowed only on certain rate plans. The room types for the first season apply automatically for all the other seasons for a given rate plan.</p>
                                            <table id='other-rateplans-table' className='table other-rateplans-table'>
                                                <thead>
                                                    <tr>
                                                        <th>Opt in</th>
                                                        <th>Rate Plan Code</th>
                                                        <th>Rate Plan Name</th>
                                                        <th>Start Date</th>
                                                        <th>End Date</th>
                                                        <th>Rate Plan Type</th>
                                                        <th>Amount</th>
                                                        <th>Room Types</th>
                                                        <th></th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        isArrayNotEmpty(values.rateplans)
                                                            ? values.rateplans.map((rateplan, rateplanIndex) => {
                                                                let cellColorClass = rateplanIndex % 2 === 0 ? 'cell-dark' : 'cell-light'
                                                                return rateplan.rates.map((rate, rateIndex) => {
                                                                    return <React.Fragment key={`rateplan-${rateplanIndex}-rate-${rateIndex}`}>
                                                                        <tr className={cellColorClass}>
                                                                            <td>
                                                                                {
                                                                                    rateplan.onboardingParticipationMandatory
                                                                                        ? rateIndex === 0
                                                                                            ? <TextInput
                                                                                                id={`opt-in-${rateplanIndex}`}
                                                                                                type='checkbox'
                                                                                                name={`rateplans.${rateplanIndex}.participating`}
                                                                                                value={rateplan.participating}
                                                                                                checked={rateplan.participating}
                                                                                                disabled={true} />
                                                                                            : <></>
                                                                                        : rateIndex === 0
                                                                                            ? <TextInput
                                                                                                id={`opt-in-${rateplanIndex}`}
                                                                                                type='checkbox'
                                                                                                name={`rateplans.${rateplanIndex}.participating`}
                                                                                                value={rateplan.participating}
                                                                                                checked={rateplan.participating} />
                                                                                            : <></>
                                                                                }
                                                                            </td>
                                                                            <td>{rateIndex === 0 ? rateplan.ratePlanCode : <></>}</td>
                                                                            <td>{rateIndex === 0 ? rateplan.ratePlanName : <></>}</td>
                                                                            <td>
                                                                                {
                                                                                    this.isSgmOrState(rateplan)
                                                                                        ? <TextInput
                                                                                            id={`start-date-${rateplanIndex}`}
                                                                                            type='date'
                                                                                            name={`rateplans.${rateplanIndex}.rates[${rateIndex}].startDate`}
                                                                                            disabled={!rateplan.participating}
                                                                                            title='Start Date' />
                                                                                        : <></>
                                                                                }

                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    this.isSgmOrState(rateplan)
                                                                                        ? <TextInput
                                                                                            id={`end-date-${rateplanIndex}`}
                                                                                            type='date'
                                                                                            name={`rateplans.${rateplanIndex}.rates[${rateIndex}].endDate`}
                                                                                            disabled={!rateplan.participating}
                                                                                            title='End Date' />
                                                                                        : <></>
                                                                                }

                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    this.isSgmOrState(rateplan)
                                                                                        && rateplan.onboardingRateChangeAllowed
                                                                                        ? (
                                                                                            rateIndex === 0
                                                                                                ? <SelectInput
                                                                                                    id={`rate-type-${rateplanIndex}`}
                                                                                                    type='date'
                                                                                                    name={`rateplans.${rateplanIndex}.ratePlanType`}
                                                                                                    selected={`rateplans.${rateplanIndex}.ratePlanType`}
                                                                                                    options={FormConst.RATE_TYPES_OPTIONS}
                                                                                                    disabled={!rateplan.participating} />
                                                                                                : <></>)
                                                                                        : FormConst.RATE_TYPE_TO_RATE_TYPE_LABEL[rateplan.ratePlanType]
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    this.isSgmOrState(rateplan)
                                                                                        && FormConst.RATE_TYPE_PERCENT === rateplan.ratePlanType
                                                                                    ? (
                                                                                        <SelectInput
                                                                                            id={`amount-type-${rateplanIndex}`}
                                                                                            name={`rateplans.${rateplanIndex}.rates[${rateIndex}].singleAmount`}
                                                                                            options={FormConst.SGM_STATE_AMOUNT_OPTIONS}
                                                                                            disabled={!values.rateplans[rateplanIndex].onboardingRateChangeAllowed || !rateplan.participating}
                                                                                            title='Select Amount Option'
                                                                                        />
                                                                                    )
                                                                                    : (

                                                                                    rateplan.ratePlanType === FormConst.RATE_TYPE_FLAT
                                                                                        ? <>
                                                                                            <TextInput
                                                                                                id={`amount-${rateplanIndex}`}
                                                                                                type='number'
                                                                                                min='0'
                                                                                                placeholder='0.00'
                                                                                                step='0.5'
                                                                                                name={`rateplans.${rateplanIndex}.rates[${rateIndex}].1P`}
                                                                                                label={FormConst.FIELD_1P}
                                                                                                disabled={!values.rateplans[rateplanIndex].onboardingRateChangeAllowed || !rateplan.participating}
                                                                                                title='1 Person Rate' />
                                                                                            <br />
                                                                                            <TextInput
                                                                                                id={`amount-${rateplanIndex}`}
                                                                                                type='number'
                                                                                                min='0'
                                                                                                placeholder='0.00'
                                                                                                step='0.5'
                                                                                                name={`rateplans.${rateplanIndex}.rates[${rateIndex}].2P`}
                                                                                                label={FormConst.FIELD_2P}
                                                                                                disabled={!values.rateplans[rateplanIndex].onboardingRateChangeAllowed || !rateplan.participating}
                                                                                                title='2 Person Rate' />
                                                                                        </>
                                                                                        : <TextInput
                                                                                            id={`amount-${rateplanIndex}`}
                                                                                            type='number'
                                                                                            min='0'
                                                                                            placeholder='0'
                                                                                            step='0.5'
                                                                                            name={`rateplans.${rateplanIndex}.rates[${rateIndex}].singleAmount`}
                                                                                            disabled={!values.rateplans[rateplanIndex].onboardingRateChangeAllowed || !rateplan.participating}
                                                                                            title='Rate Amount' />
                                                                                    )
                                                                                }

                                                                                {
                                                                                    rateplan.ratePlanCode === FormConst.RATEPLAN_CODE_SRD
                                                                                    && <>
                                                                                        <br />
                                                                                        <p>Rate will be calculated based on ADR</p>
                                                                                    </>
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    rateIndex === 0
                                                                                        ? this.state.isEditRoomTypes[rateplanIndex]
                                                                                            ?
                                                                                            (
                                                                                                <span className='room-types-fields'>
                                                                                                    {rate.roomTypes.map((roomType, roomTypeIndex) => {
                                                                                                        return <TextInput
                                                                                                            id={`room-type-${roomTypeIndex}`}
                                                                                                            type='checkbox'
                                                                                                            name={`rateplans.${rateplanIndex}.rates.${rateIndex}.roomTypes.${roomTypeIndex}.isChecked`}
                                                                                                            value={roomType.isChecked}
                                                                                                            checked={roomType.isChecked}
                                                                                                            suffix={roomType.code} />
                                                                                                    })}
                                                                                                </span>
                                                                                            )
                                                                                            :
                                                                                            (
                                                                                                this.isAllRoomTypes(rate.roomTypes)
                                                                                                    ? <>ALL</>
                                                                                                    : <span className='room-types-fields'>
                                                                                                        {rate.roomTypes.map((roomType, roomTypeIndex) => {
                                                                                                            return <TextInput
                                                                                                                id={`room-type-${roomTypeIndex}`}
                                                                                                                type='checkbox'
                                                                                                                name={`rateplans.${rateplanIndex}.rates.${rateIndex}.roomTypes.${roomTypeIndex}.isChecked`}
                                                                                                                value={roomType.isChecked}
                                                                                                                checked={roomType.isChecked}
                                                                                                                suffix={roomType.code}
                                                                                                                disabled={true} />
                                                                                                        })}
                                                                                                    </span>
                                                                                            )
                                                                                        : <></>
                                                                                }

                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    rateplan.participating
                                                                                    && rateplan.onboardingRoomTypeChangeAllowed
                                                                                    && (
                                                                                        rateIndex === 0 &&
                                                                                        (
                                                                                            this.state.isEditRoomTypes[rateplanIndex]
                                                                                                ? <Button role='link' name='Save' onClick={() => this.onSaveRoomTypes(rateplanIndex)} />
                                                                                                : <Button role='link' name='Change Room Types' onClick={() => this.onEditRoomTypes(rateplanIndex)} />
                                                                                        )
                                                                                    )
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {
                                                                                    // Show seasons only for SGM and STATE
                                                                                    this.isSgmOrState(rateplan)
                                                                                    && rateplan.participating
                                                                                    && rateplan.allowSeasons
                                                                                    && (
                                                                                        rateIndex === 0
                                                                                            ? <Button role='link' name='Add Season' onClick={() => this.addSeason(values, rateplanIndex)} />
                                                                                            : <Button role='link' name='Delete Season' onClick={() => this.deleteSeason(values, rateplanIndex, rateIndex)} />
                                                                                    )
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            {
                                                                                rateIndex === 0
                                                                                && errors
                                                                                && isArrayNotEmpty(errors.rateplans)
                                                                                && errors.rateplans[rateplanIndex]
                                                                                && errors.rateplans[rateplanIndex].rates
                                                                                && typeof (errors.rateplans[rateplanIndex].rates) === 'string'
                                                                                && <td colSpan={10} className={'error mt-3 text-bold text-center ' + cellColorClass}>{errors.rateplans[rateplanIndex].rates}</td>
                                                                            }
                                                                        </tr>
                                                                    </React.Fragment>
                                                                }
                                                                )
                                                            })
                                                            : (
                                                                <tr>
                                                                    <td colSpan="10" className='text-center'>No other rate plans found</td>
                                                                </tr>
                                                            )
                                                    }
                                                </tbody>
                                            </table>
                                            <FormFooter
                                                form={{
                                                    previous: { title: 'Third party Rate Programs', route: RouteConst.ROUTE_OTA_RATE_PROGRAMS_PAGE },
                                                    next: { title: 'Rateplan Blackouts', route: RouteConst.ROUTE_RATEPLAN_BLACKOUTS_PAGE }
                                                }}
                                                isSubmit
                                                submitName={FormConst.SAVE_BUTTON_TEXT}
                                                noReset
                                                submitDisabled={isSubmitting} />
                                            <FormModal
                                                id='hotel-info-page-save-modal'
                                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                                hotelInfo={this.state.hotelInfo}
                                                body={<h6>{this.state.loadingMessage}</h6>}
                                                show={this.state.isLoading}
                                                isLoadingIndicator />
                                            <FormModal
                                                id='hotel-info-page-reset-modal'
                                                hotelInfo={this.state.hotelInfo}
                                                title={FormConst.MODAL_RESET_ACTION_TITLE}
                                                body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                                proceed={() => {
                                                    this.resetFormData(resetForm)
                                                }}
                                                cancel={() => { this.setState({ showResetModal: false }) }}
                                                show={this.state.showResetModal} />
                                            <FormModal
                                                id='hotel-info-page-error-modal'
                                                hotelInfo={this.state.hotelInfo}
                                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                                body={<h5>{this.state.errorMessage}</h5>}
                                                isError
                                                cancel={() => { this.setState({ showErrorModal: false }) }}
                                                show={this.state.showErrorModal} />
                                        </div>
                                    </Form>
                                </div>
                            </>
                        )
                    }
                </Formik>
            </div>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        rateplansResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_OTHER_RATEPLANS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(OtherRateplans, SideNavEntryMapping.RATE_PLANS))
